import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function DigitalAssets() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Digital Assets" breadcrumbItem="Digital Assets" />
          <h4>DigitalAssets</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default DigitalAssets;
